import { Map } from "immutable"

import {
    SOURCE_LIST_REQUEST as LIST_REQUEST,
    SOURCE_LIST_RESPONSE as LIST_RESPONSE,
    SOURCE_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    SOURCE_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE,
    SOURCE_ITEM_DELETE_RESPONSE as ITEM_DELETE_RESPONSE
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"

export const defaultSearchCriteria = Map({
    name: ""
})

export default buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE,
        ITEM_DELETE_RESPONSE
    },
    defaultSearchCriteria
)
